var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('a-config-provider',{attrs:{"locale":_vm.locale,"getPopupContainer":_vm.getPopupContainer}},[_c('a-spin',_vm._b({staticClass:"page-loading"},'a-spin',_vm.loadingProps,false),[_c('router-view')],1)],1):_c('div',{staticClass:"app-loading"},[_c('a-spin',{staticClass:"app-loading__spin"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29051434","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 